module.exports = __webpack_public_path__ + "static/how-it-works-3-24402272edf1b6f16e4821b4070fb098.svg";